































































import { Component, Vue } from 'vue-property-decorator';
import { patterns } from '@easygenerator/fragment-sdk';
import Checkbox from '@/components/auth-form/Checkbox.vue';
import InputField from '@/components/auth-form/InputField.vue';
import SocialAuth from '@/components/auth-form/SocialAuth.vue';
import PasswordField from '@/components/auth-form/PasswordField.vue';
import Notification from '@/components/notification/Notification.vue';
import { EULA_URL } from '../../constants';
import { MAX_LENGTH, OnValidatedCallback, userNamePattern } from '../../types/constants';

@Component({
  components: { Checkbox, PasswordField, Notification, InputField, SocialAuth },
  metaInfo(this: SignupForm) {
    return {
      meta: this.metaTags,
      title: this.$t('learnerPageTitle')
    };
  }
})
export default class SignupForm extends Vue {
  get eulaUrl() {
    return EULA_URL;
  }

  get metaTags() {
    return [
      { name: 'title', content: this.$t('learnerPageTitle') },
      { name: 'description', content: this.$t('signUpDescription') },
      { property: 'og:title', content: this.$t('learnerPageTitle') },
      { property: 'og:description', content: this.$t('signUpDescription') }
    ];
  }

  userNamePattern: () => RegExp = userNamePattern;

  emailPattern: () => RegExp = patterns.email;

  nameValue: string = '';

  emailValue: string = '';

  passwordValue: string = '';

  nameMaxLength = MAX_LENGTH.NAME;

  emailMaxLength = MAX_LENGTH.EMAIL;

  isAgreementAcceptedDirty = false;

  isAgreementAccepted = false;

  get isAgreementAcceptedIncorrect() {
    return this.isAgreementAcceptedDirty && !this.isAgreementAccepted;
  }

  created() {
    this.emailValue = this.getEmailFromQueryParams();
  }

  getEmailFromQueryParams(): string {
    const params = new URLSearchParams(window.location.href.split('?')[1]);
    
    return params.get('email') || '';
  }

  async validateForm() {
    return (
      await Promise.all([
        this.validateField('name'),
        this.validateField('email'),
        this.validateField('password'),
        this.validateField('agreement')
      ])
    ).every(item => item);
  }

  async validateField(name: string) {
    return new Promise(resolve => {
      const callback: OnValidatedCallback = async isValidPromise => resolve(await isValidPromise);

      this.$emit(`validate:${name}`, callback);
    });
  }

  agreementUpdated() {
    this.isAgreementAcceptedDirty = true;
    this.isAgreementAccepted = !this.isAgreementAccepted;
  }

  async submitForm() {
    const isFormValid = await this.validateForm();
    if (!isFormValid) {
      return;
    }

    const name = this.nameValue.trim();
    const email = this.emailValue.trim();
    const password = this.passwordValue.trim();

    await this.$store.dispatch('app/registerUser', { email, password, name });

    this.$router.push({ name: 'Dashboard' });
  }

  async validateEmail() {
    if (await this.checkIfUserExists(this.emailValue)) {
      throw new Error(this.$t('userExistText'));
    }

    return true;
  }

  async checkIfUserExists(email: string) {
    const response = await this.$store.dispatch('app/checkIfUserExists', { email });
    return !!response.exists;
  }
}
